<template>
  <v-dialog
    :model-value="modelValue"
    width="800"
    @update:model-value="onDialogVisibility"
    @click:outside="closeModal"
  >
    <v-card rounded="lg">
      <div class="bg-red-600 relative">
        <i
          class="mdi mdi-close text-xl cursor-pointer text-white absolute top-2 right-3"
          @click="closeModal"
        ></i>
        <h2 class="text-xl font-semibold text-white py-5 pl-10">
          Amandemen IMKP
        </h2>
      </div>

      <div class="px-10 py-5">
        <div v-if="loading" class="py-10 text-center text-gray-500">
          Memuat data amandemen…
        </div>

        <template v-else>
          <v-form ref="formAmandemen" @submit.prevent="handleSubmit">
            <table class="table table-striped">
              <thead class="table-danger fw-bold">
                <tr>
                  <td colspan="4">
                    <p class="fs-8 fw-bold ms-2 m-0">Detail Izin</p>
                  </td>
                </tr>
              </thead>
              <tbody class="fs-8">
                <TableComponent
                  :data="detailIzin"
                  :column="2"
                  :subTitle="false"
                />
                <template v-if="buttonAmandemen">
                  <tr>
                    <td class="bg-red">
                      <p class="fs-8 ms-2 m-0">Selesai Pekerjaan</p>
                    </td>
                    <td colspan="3">
                      <FormDate
                        v-model="formAmandemen.tanggalSelesai"
                        placeholder="Pilih tanggal selesai"
                        :min="minTanggalSelesai"
                        required
                        :rules="formValidasi.tanggalSelesai"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-red">
                      <p class="fs-8 ms-2 m-0">
                        Dokumen Keterangan Persetujuan Perpanjangan Waktu Proyek
                      </p>
                    </td>
                    <td colspan="3">
                      <v-file-input
                        v-model="formAmandemen.file"
                        accept=".pdf"
                        variant="outlined"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-cloud-upload-outline"
                        color="#475569"
                        multiple
                        chips
                        hide-details="auto"
                        :rules="formValidasi.file"
                        @update:model-value="onFileChange"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-red">
                      <p class="fs-8 ms-2 m-0">Alasan Amandemen</p>
                    </td>
                    <td colspan="3">
                      <FormTextarea
                        v-model="formAmandemen.reason"
                        required
                        :rules="formValidasi.reason"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-red">
                      <p class="fs-8 ms-2 m-0">Durasi</p>
                    </td>
                    <td colspan="3">
                      <p class="fs-8 m-0">
                        {{ formAmandemen.durasi + " Hari" }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-red">
                      <p class="fs-8 ms-2 m-0">Nomor Izin</p>
                    </td>
                    <td colspan="3">
                      <p class="fs-8 m-0">{{ formAmandemen.nomorIzin }}</p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <div class="flex justify-between mt-4">
              <FormButton
                label="History"
                classes="bg-red-600 text-white capitalize"
                @click="$emit('open-history', imkpId)"
              />
              <div class="flex justify-end gap-3">
                <FormButton
                  label="Tutup"
                  variant="outlined"
                  classes="capitalize text-gray-500"
                  @click="closeModal"
                />
                <FormButton
                  v-if="buttonAmandemen"
                  label="Simpan"
                  classes="bg-red-600 text-white capitalize"
                  @click="handleSubmit"
                />
              </div>
            </div>
          </v-form>
        </template>
      </div>
    </v-card>
  </v-dialog>

  <ConfirmModal
    v-model="dialogConfirm"
    img="warning.png"
    title="Amandemen IMKP"
    description="Apakah anda yakin akan melakukan Amandemen IMKP ini?"
    wording-cancel="Batal"
    wording-confirm="Ya"
    :loading="submitting"
    @close-modal="dialogConfirm = false"
    @confirm-data="submitAmandemen"
  />
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import FormButton from "@/components/FormButton.vue";
import FormDate from "@/components/FormDate.vue";
import FormTextarea from "@/components/FormTextarea.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import TableComponent from "./TableComponent.vue";
import axios from "axios";
import moment from "moment";
import {
  API_BASE_URL,
  CMS_IMKP_DETAIL,
  CMS_GET_IMKP_TEMP,
  CMS_SET_IMKP_AMANDEMEN_KONTRAKTOR,
} from "@/constants";
import { downloadFile } from "@/utilities/globalFunction";
import UploadFileService from "@/utilities/upload-file";
import { FormValidasiImkp } from "@/pages/imkp/core/FormData";
import util from "@/assets/js/util";
import { formatSubLokasiDisplay } from "@/pages/imkp/core/subLokasiHelpers";
import { fixDate } from "@/utilities/helpers.js";

moment.locale("id");

const url_imkp_detail = API_BASE_URL + CMS_IMKP_DETAIL;
const url_imkp_temp = API_BASE_URL + CMS_GET_IMKP_TEMP;
const url_imkp_amandemen = API_BASE_URL + CMS_SET_IMKP_AMANDEMEN_KONTRAKTOR;
const max_file_size = 5;

const EMPTY_FORM = {
  id: null,
  tanggalSelesai: null,
  durasi: null,
  nomorIzin: null,
  reason: null,
  file: [],
  assets: [],
};

export default {
  name: "AmandemenImkpModal",
  mixins: [GlobalDataMixin],
  components: {
    FormButton,
    FormDate,
    FormTextarea,
    ConfirmModal,
    TableComponent,
  },
  emits: ["update:modelValue", "submitted", "open-history"],
  props: {
    modelValue: { type: Boolean, default: false },
    imkpId: { type: [Number, String], default: null },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogConfirm: false,
      buttonAmandemen: false,
      detailIzin: [],
      mulaiDate: null,
      formAmandemen: { ...EMPTY_FORM },
    };
  },
  computed: {
    userRole() {
      return Array.isArray(this.userData.role) ? "isafe" : this.userData.role;
    },
    minTanggalSelesai() {
      if (!this.mulaiDate) return undefined;
      return new Date(this.mulaiDate.getTime() + 86400000);
    },
    formValidasi() {
      return {
        tanggalSelesai: FormValidasiImkp.selesaiPekerjaan,
        file: FormValidasiImkp.filePersyaratanKhusus,
        reason: [
          (v) => !!String(v || "").trim() || "Alasan amandemen harus diisi.",
        ],
      };
    },
  },
  created() {
    this.uploadFileService = new UploadFileService(
      this.userData.token,
      this.userRole,
    );
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.resetForm();
        this.fetchDetail();
      } else {
        this.resetForm();
      }
    },
    "formAmandemen.tanggalSelesai"() {
      const mulai = this.mulaiDate;
      const selesai = this.formAmandemen.tanggalSelesai
        ? new Date(this.formAmandemen.tanggalSelesai)
        : null;

      if (mulai && selesai && !isNaN(mulai) && !isNaN(selesai)) {
        const diffTime = selesai.getTime() - mulai.getTime();
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        this.formAmandemen.durasi = Math.round(diffDays);
      } else {
        this.formAmandemen.durasi = "-";
      }
    },
  },
  methods: {
    downloadFile,
    formatSubLokasiDisplay,
    resetForm() {
      this.formAmandemen = { ...EMPTY_FORM, file: [], assets: [] };
      this.detailIzin = [];
      this.buttonAmandemen = false;
      this.mulaiDate = null;
      this.dialogConfirm = false;
      this.$nextTick(() => {
        this.$refs.formAmandemen?.resetValidation();
      });
    },
    async handleSubmit() {
      const { valid } = await this.$refs.formAmandemen.validate();
      if (!valid) return;
      this.dialogConfirm = true;
    },
    async fetchDetail() {
      if (!this.imkpId) return;
      try {
        this.loading = true;

        const temp = await axios.get(url_imkp_temp, {
          params: { imkpId: this.imkpId },
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        this.buttonAmandemen = temp.data.data.length === 0;

        const result = await axios.get(url_imkp_detail, {
          params: { id: this.imkpId },
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        const res = result.data.data[0];
        if (!res) return;

        const mulai = new Date(res.tanggalMulaiPekerjaan);
        const selesai = new Date(res.tanggalSelesaiPekerjaan);
        this.mulaiDate = !isNaN(mulai) ? mulai : null;

        if (mulai && selesai && !isNaN(mulai) && !isNaN(selesai)) {
          const diffTime = selesai.getTime() - mulai.getTime();
          const diffDays = diffTime / (1000 * 60 * 60 * 24);
          this.formAmandemen.durasi = Math.round(diffDays) + " Hari";
        } else {
          this.formAmandemen.durasi = "-";
        }

        this.formAmandemen.id = this.imkpId;
        this.formAmandemen.tanggalSelesai = selesai;
        this.formAmandemen.nomorIzin = res.nomorIzin;

        this.detailIzin = [
          {
            id: 1,
            label: "Kontraktor / Subkontraktor",
            value: this.userData.kontraktorName,
          },
          { id: 2, label: "Nama Pemegang Izin", value: res.namaPemegangIzin },
          { id: 3, label: "Lokasi Kerja", value: res.lokasiKerja },
          {
            id: 4,
            label: "Sub Lokasi Kerja",
            value: formatSubLokasiDisplay(res.subLokasi),
          },
          {
            id: 5,
            label: "Keterangan Lokasi Proyek",
            value: res.keteranganLokasiKerja,
          },
          { id: 6, label: "Judul Proyek", value: res.judulProyek },
          {
            id: 7,
            label: "Mulai Pekerjaan",
            value: res.tanggalMulaiPekerjaan
              ? moment(new Date(res.tanggalMulaiPekerjaan)).format(
                  "DD MMMM YYYY",
                )
              : "-",
          },
        ];

        if (!this.buttonAmandemen) {
          this.detailIzin.push(
            {
              id: 8,
              label: "Selesai Pekerjaan",
              value: temp.data.data[0].tanggalSelesaiPekerjaan
                ? moment(
                    new Date(temp.data.data[0].tanggalSelesaiPekerjaan),
                  ).format("DD MMMM YYYY")
                : moment(new Date(res.tanggalSelesaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  ),
            },
            {
              id: 9,
              label: "Dokumen Keterangan Persetujuan Perpanjangan Waktu Proyek",
              value: temp.data.data[0].fileAmandemen
                ? JSON.parse(temp.data.data[0].fileAmandemen)
                : [],
              title: "File Amandemen",
              file: true,
            },
            {
              id: 10,
              label: "Alasan Amandemen",
              value: temp.data.data[0].alasanAmandemen,
              textArea: true,
            },
            { id: 11, label: "Durasi", value: this.formAmandemen.durasi },
            { id: 12, label: "Nomor Izin", value: res.nomorIzin },
          );
        }
      } catch (error) {
        console.log("ERR fetchDetail Amandemen : ", error);
        util.showError("Terjadi kesalahan saat memuat data amandemen.");
      } finally {
        this.loading = false;
      }
    },
    onFileChange(files) {
      const arrFile = Array.isArray(files) ? files : files ? [files] : [];
      const invalid = arrFile.find(
        (item) =>
          item.type !== "application/pdf" ||
          item.size > max_file_size * 1024 * 1024,
      );

      if (invalid) {
        if (invalid.type !== "application/pdf") {
          util.showError("Ekstensi file harus .pdf!");
        } else {
          util.showError(
            "Ukuran file melebihi batas max " + max_file_size + "MB !",
          );
        }
        this.formAmandemen.file = [];
        return;
      }

      this.formAmandemen.file = arrFile;
    },
    async uploadFiles() {
      this.formAmandemen.assets = [];
      for (const file of this.formAmandemen.file) {
        try {
          const res = await this.uploadFileService.uploadFile(file);
          this.formAmandemen.assets.push(res.filename);
        } catch (error) {
          util.showError("Terjadi kesalahan saat upload file!");
        }
      }
    },
    async submitAmandemen() {
      try {
        this.submitting = true;
        await this.uploadFiles();

        const bodyJson = {
          usecase: "kontraktor",
          idIzinKontrak: this.formAmandemen.id,
          tanggalSelesaiPekerjaan: fixDate(this.formAmandemen.tanggalSelesai),
          alasanAmandemen: this.formAmandemen.reason,
          fileAmandemen: JSON.stringify(this.formAmandemen.assets),
        };

        await axios.post(url_imkp_amandemen, bodyJson, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        util.showInfo("Amandemen IMKP berhasil!", 2000);
        this.dialogConfirm = false;
        this.$emit("submitted");
        this.closeModal();
      } catch (error) {
        console.log("ERR submitAmandemen : ", error);
        util.showError("Terjadi kesalahan saat submit Amandemen IMKP!");
      } finally {
        this.submitting = false;
      }
    },
    closeModal() {
      this.onDialogVisibility(false);
    },
    onDialogVisibility(open) {
      this.$emit("update:modelValue", open);
    },
  },
};
</script>

<style scoped>
tr td.bg-red:first-child {
  background: #f8e3e5;
}
tr td.bg-red:first-child p {
  font-weight: 600;
}
</style>
